module.exports = "app-no-connection p:first-child {\n  margin-top: 15vh;\n  margin-bottom: 50px; }\n\napp-no-connection button {\n  margin-top: 50px; }\n\napp-no-connection i {\n  font-size: 6em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-connection/no-connection.component.scss
// module id = ./src/app/no-connection/no-connection.component.scss
// module chunks = main